(function () {
  'use strict';

  function pushEvent(name, details) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, details || {}));
  }

  function initializeLanding(root) {
    if (!root || root.dataset.proLandingReady === 'true') return;
    root.dataset.proLandingReady = 'true';

    root.querySelectorAll('[data-pro-cta-location]').forEach(function (link) {
      link.addEventListener('click', function () {
        pushEvent('pro_landing_cta', {
          cta_location: link.getAttribute('data-pro-cta-location'),
          destination: 'jotform_pro_application',
          landing_page_path: window.location.pathname,
        });
      });
    });

    root.querySelectorAll('.sh-pro__faq-item').forEach(function (item, index) {
      var summary = item.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', function () {
        if (item.open) return;
        pushEvent('pro_landing_faq_open', {
          faq_position: index + 1,
          faq_question: summary.textContent.trim(),
          landing_page_path: window.location.pathname,
        });
      });
    });

    root.dataset.proLandingBound = 'true';
  }

  function initializeAll() {
    document.querySelectorAll('[data-pro-landing]').forEach(initializeLanding);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', initializeAll);
})();
